import React from 'react';
import Box, { type BoxProps } from '@mui/material/Box';
import {
  CheckCircle,
  ContactSupport,
  HourglassTop,
  SearchOff,
} from '@mui/icons-material';
import styled from 'styled-components';

export type BoxPanelProps = {
  icon: 'succeed' | 'failed' | 'pending' | 'unFinished';
  title?: string;
  description?: React.ReactNode;
} & BoxProps;

export const BoxPanel: React.FC<BoxPanelProps> = (props: BoxPanelProps) => {
  const { icon, title, description, sx } = props;

  const iconMapping = new Map<string, React.ReactNode>([
    ['succeed', <CheckCircle key="succeed" sx={{ color: 'green' }} />],
    ['failed', <ContactSupport key="failed" sx={{ color: 'red' }} />],
    ['pending', <HourglassTop key="pending" sx={{ color: 'orange' }} />],
    ['unFinished', <SearchOff key="unFinished" sx={{ color: 'orange' }} />],
  ]);

  return (
    <Box sx={sx}>
      <TitleStyle>
        <div>{iconMapping.get(icon)}</div>
        <h2>{title}</h2>
      </TitleStyle>
      <div>{description}</div>
    </Box>
  );
};

const TitleStyle = styled.div`
  display: flex;
  flex-direction: row;

  div {
    margin-left: 2px;
    margin-right: 2px;
  }
  h2 {
    margin: 0;
    font-weight: bold;
  }
`;
